import React from 'react';
import { connect } from 'react-redux';
import SidebarHeading from './SidebarHeading';
import Menu from './Menu';
import '../css/elements/left-sidebar-1.css';
import '../css/elements/collapsed-left-sidebar-1.css';

const LeftSidebar = ({ navigation, config }) => {
  const { layout } = config;
  if (
    !layout ||
    layout === 'top-navigation-1' ||
    layout === 'empty-view-1' ||
    layout === 'empty-view-2'
  ) {
    return <div />;
  }
  return (
    <div>
      <div className="left-sidebar-placeholder" />
      <div className="left-sidebar left-sidebar-1">
        <div className="wrapper">
          <div className="content">
            <SidebarHeading />
            {navigation.map((menu, i) => (
              <div key={i} className="section">
                <div className="section-title">{menu.title}</div>
                <ul className="list-unstyled">
                  {menu.items.map((item, i) => (
                    <Menu key={i} items={item} />
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state, ownProps) => ({
  navigation: state.navigation,
  config: state.config,
});
export default connect(mapStateToProps)(LeftSidebar);



// WEBPACK FOOTER //
// ./src/elements/LeftSidebar.js